import api from "./api";

// Fetch the store's white-label branding once and share it across components.
let cache = null;

export function getBranding() {
  if (!cache) {
    cache = api.get("/branding").then((r) => r.data).catch(() => ({}));
  }
  return cache;
}
